export default __webpack_public_path__ + "static/media/indicator-sect5-pattern.b70a122f.svg";